import React from 'react';
import { Link } from 'react-router-dom';
import { usePageContent } from '../hooks/usePageContent';

const DEFAULT_SITE = {
    name: 'Chaw Thinn',
    footerHeading: "Let's build something useful.",
};

export default function Footer() {
    const year = new Date().getFullYear();
    const { content } = usePageContent('contact');
    const { content: siteContent } = usePageContent('site');
    const site = siteContent || DEFAULT_SITE;

    const channels = content?.channels || [];
    const emailChannel = channels.find(c => c.label?.toLowerCase() === 'email');
    // Filter out Email from contact channels
    const elsewhereLinks = channels.filter(c => c.label?.toLowerCase() !== 'email');

    return (
        <footer className="border-t border-line mt-12 md:mt-24">
            <div className="container-page py-10 flex flex-col md:flex-row md:items-start md:justify-between gap-8">
                <div>
                    <p className="font-display text-2xl tracking-tight text-fg mb-2">
                        {site.footerHeading || DEFAULT_SITE.footerHeading}
                    </p>
                    {emailChannel?.value && (
                        <a
                            href={emailChannel.href || `mailto:${emailChannel.value}`}
                            className="link-underline text-fg"
                        >
                            {emailChannel.value}
                        </a>
                    )}
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-12 gap-y-3 text-[13px]">
                    <FooterCol title="Site">
                        <Link to="/" className="text-fg-muted hover:text-fg transition-colors">Home</Link>
                        <Link to="/work" className="text-fg-muted hover:text-fg transition-colors">Work</Link>
                        <Link to="/about" className="text-fg-muted hover:text-fg transition-colors">About</Link>
                        <Link to="/writing" className="text-fg-muted hover:text-fg transition-colors">Writing</Link>
                        <Link to="/contact" className="text-fg-muted hover:text-fg transition-colors">Contact</Link>
                    </FooterCol>
                    <FooterCol title="Elsewhere">
                        {elsewhereLinks.map((link) => (
                            <a
                                key={link.label}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-fg-muted hover:text-fg transition-colors"
                            >
                                {link.label}
                            </a>
                        ))}
                    </FooterCol>
                </div>
            </div>

            <div className="container-page pb-8 flex items-center justify-between text-[12px] text-fg-soft">
                <span>© {year} {site.name || DEFAULT_SITE.name}</span>
                <span className="font-mono">v1.0</span>
            </div>
        </footer>
    );
}

function FooterCol({ title, children }) {
    return (
        <div className="flex flex-col gap-2">
            <p className="eyebrow mb-1">{title}</p>
            {children}
        </div>
    );
}
